import React from 'react'
import PromoCodeTable from './Components/PromoCodeTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PromoCodeList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Promo Code List</HeadingOne>
          <AddItemBtn url="add-promo-code" title="Add Promo Code" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PromoCodeTable />
      </div>
    </PageBody>
  );
};

export default PromoCodeList;
